import styled, { css } from 'styled-components';
import closeIcon from 'assets/images/close-icon.svg';
import { fonts } from 'styles';

interface ModalPros {
  isOpen: boolean;
}

export const Container = styled.div<ModalPros>`
  width: 100%;
  height: 100vh;
  display: none;
  background-color: #efe9dc;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;

  ${({ isOpen }) =>
    isOpen &&
    css`
      display: block;
      animation: appear 300ms ease;

      @keyframes appear {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    `};
`;

export const Content = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 160px 96px;
  column-gap: 88px;
  overflow-y: auto;

  @media screen and (max-width: 1366px) {
    padding: 96px 48px;
    column-gap: 48px;
  }

  @media screen and (max-width: 1270px) {
    display: block;
    padding: 0;
    column-gap: 0;
    flex-direction: column-reverse;
  }
`;

export const Video = styled.div`
  width: 100%;
  max-width: 60%;

  @media screen and (max-width: 1270px) {
    display: none;
  }
`;

export const VideoMobile = styled.div`
  width: 100%;
  display: none;
  @media screen and (max-width: 1270px) {
    display: block;
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;

  .react-player {
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const Infos = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 40%;

  @media screen and (max-width: 1270px) {
    max-width: 100%;
    padding: 108px 40px 40px 40px;
    height: auto;
  }
`;

export const InfoHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 32px;
  margin-bottom: 32px;
  border-bottom: 4px solid #3b38b9;
`;

export const InfoTitle = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 46px;
  color: #3b38b9;
  text-transform: uppercase;

  @media screen and (max-width: 1366px) {
    font-size: 40px;
  }

  @media screen and (max-width: 500px) {
    font-size: 28px;
    flex: 1;
  }
`;

export const InfoText = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 26px;
  color: #3b38b9;
  text-align: left;
`;

export const CloseIcon = styled.img.attrs({ src: closeIcon })``;

export const CloseButton = styled.button.attrs({ type: 'button' })``;
